import styled, { keyframes } from 'styled-components';

// @ts-nocheck
var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var bounce = keyframes(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}"]);
var CONTAINER_WIDTHS = {
  s: '30px',
  m: '60px'
};
var DOT_SIZES = {
  s: '7px',
  m: '14px'
};
var DOT_MARGINS = {
  s: 'auto 4px',
  m: 'auto 7px'
};
var delay = 0.25;
var BounceLoader = styled.div.withConfig({
  displayName: "style__BounceLoader",
  componentId: "sc-1maoaf7-0"
})(["animation-duration:", "s;animation-name:", ";opacity:1;position:relative;text-align:center;width:", ";display:table;margin:0 auto;"], delay, fadeIn, function (_ref) {
  var $size = _ref.$size;
  return CONTAINER_WIDTHS[$size];
});
var Dot = styled.div.withConfig({
  displayName: "style__Dot",
  componentId: "sc-1maoaf7-1"
})(["animation-duration:1.4s;animation-iteration-count:infinite;animation-name:", ";background-color:var(--color-grey-800);border-radius:100%;display:inline-block;height:", ";width:", ";&:nth-child(1){animation-delay:", "s;}&:nth-child(2){animation-delay:", "s;margin:", ";}"], bounce, function (_ref2) {
  var $size = _ref2.$size;
  return DOT_SIZES[$size];
}, function (_ref3) {
  var $size = _ref3.$size;
  return DOT_SIZES[$size];
}, -delay, -delay / 2, function (_ref4) {
  var $size = _ref4.$size;
  return DOT_MARGINS[$size];
});

export { BounceLoader, Dot };
//# sourceMappingURL=style.js.map
